import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

// Rotas em que o botao "voltar" do Android deve fechar o app em vez de navegar,
// porque nao existe tela anterior que faca sentido.
const ROTAS_RAIZ = ['/', '/dashboard'];

export const isNative = () => Capacitor.isNativePlatform();

/**
 * Ajustes que so existem no app nativo (Android). No navegador nao faz nada,
 * entao o mesmo codigo continua servindo o site.
 */
function NativeShell() {
	const navigate = useNavigate();
	const location = useLocation();

	// Barra de status na cor da marca e splash escondida depois que o React montou.
	useEffect(() => {
		if (!isNative()) return;

		StatusBar.setStyle({ style: Style.Dark }).catch(() => { });
		StatusBar.setBackgroundColor({ color: '#233344' }).catch(() => { });
		SplashScreen.hide().catch(() => { });
	}, []);

	// Botao fisico de voltar: navega no historico do react-router e so fecha o
	// app quando ja estamos numa tela raiz.
	useEffect(() => {
		if (!isNative()) return;

		let listener;

		CapacitorApp.addListener('backButton', () => {
			const naRaiz = ROTAS_RAIZ.includes(location.pathname);
			// O react-router guarda o indice da entrada atual no history.state.
			const temTelaAnterior = (window.history.state?.idx ?? 0) > 0;

			if (naRaiz || !temTelaAnterior) {
				CapacitorApp.exitApp();
				return;
			}

			navigate(-1);
		}).then((handle) => {
			listener = handle;
		});

		return () => {
			listener?.remove();
		};
	}, [location.pathname, navigate]);

	return null;
}

export default NativeShell;
